<template>
  <div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>
              <p><strong>参数名</strong></p>
            </th>
            <th>
              <p><strong>值</strong></p>
            </th>
            <th>
              <p><strong>含义</strong></p>
            </th>
            <th>
              <p><strong>是否必填</strong></p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p>keywords</p>
            </td>
            <td>
              <el-input v-model="params.keywords"
                        size="small"
                        placeholder="查询关键字" />
            </td>
            <td>
              <p>
                查询关键字
              </p>
            </td>
            <td>
              <p>是</p>
            </td>
          </tr>
          <tr>
            <td>
              <p>subdistrict</p>
            </td>
            <td>
              <el-input v-model="params.subdistrict"
                        size="small"
                        placeholder="子级行政区" />
            </td>
            <td>
              <p>子级行政区
              </p>
            </td>
            <td>
              <p>否</p>
            </td>
          </tr>
          <tr>
            <td>
              <p>show_fields</p>
            </td>
            <td>
              <el-input v-model="params.show_fields"
                        size="small"
                        placeholder="返回结果控制" />
            </td>
            <td>
              <p>返回结果控制
              </p>
            </td>
            <td>
              <p>否</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style="margin-top: 12px">
      <button class="black-btn"
              @click="run">运行</button>
    </div>
    <div v-if="res"
         class="result-container">
      <div class="header">
        <div class="button-container"
             v-if="depth === 1"
             style="margin-right:18px"
             @click="expand">
          <img src="../assets/icon-expand.svg"
               alt="">
          <el-button type="text"
                     size="small">全部展开</el-button>
        </div>
        <div class="button-container"
             v-if="depth === 5"
             style="margin-right:18px"
             @click="collapse">
          <img src="../assets/icon-collapse.svg"
               alt="">
          <el-button type="text"
                     size="small">全部折叠</el-button>
        </div>
        <div class="button-container"
             @click="res = null">
          <img src="../assets/icon-close.svg"
               alt="">
          <el-button type="text"
                     size="small">关闭</el-button>
        </div>
      </div>
      <div class="url">{{ showUrl }}</div>
      <div>
        <vue-json-pretty v-if="res"
                         :data="res"
                         class="json-container"
                         :deep="depth"> </vue-json-pretty>
      </div>
    </div>
  </div>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
  components: {
    VueJsonPretty
  },
  data() {
    return {
      params: {
        key: 'lbs-meituan-demo',
        keywords: '',
        subdistrict: '',
        show_fields: ''
      },
      baseUrl: 'https://lbsapi.meituan.com/v1/search/division',
      url: '',
      showUrl: '',
      res: null,
      expanded: true,
      depth: 1
    };
  },
  methods: {
    run() {
      //
      const baseUrl = this.baseUrl;
      const params = this.params;
      this.url = `${baseUrl}?${this.$qs.stringify(params)}`;
      this.$http.get(this.url).then((res) => {
        this.res = res.data;
      });
      this.showUrl = this.url.replace('lbs-meituan-demo', '您的key');
    },
    expand() {
      const res = this.res;
      this.depth = 5;
      this.res = null;
      this.$nextTick(() => {
        this.res = res;
      });
    },
    collapse() {
      const res = this.res;
      this.depth = 1;
      this.res = null;
      this.$nextTick(() => {
        this.res = res;
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import '../document.less';
</style>
